module.exports = __webpack_public_path__ + "static/media/save.00362812.SVG";